import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import {
  CampaignOfferProps,
  OfferModalProps,
} from '@core/Entities/OfferPromoContent/OfferPromoContent.entity';
import { sessionStorageHelper } from '@core/Utils/SessionStorageHelper';

export const offerModalAtom = atom<OfferModalProps | null>(null);

export const offerModalWithStorageAtom = atomWithStorage<OfferModalProps | null>(
  'offerModalData',
  null,
  sessionStorageHelper as any,
);

export const campaignOfferStorageAtom = atomWithStorage<CampaignOfferProps[] | null>(
  'campaignOfferData',
  null,
  sessionStorageHelper as any,
);
